import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as bovenLokaliteitPerInfrastructuurActions from "../../actions/bovenLokaliteitPerInfrastructuurActions";
import * as infrastructuurActions from "../../actions/infrastructuurActions";
import * as layoutActions from "../../actions/layoutActions";
import * as pageConstants from "../../constants/EasterEggConstants";

import * as documentActions from "../../actions/documentActions";

import AutoBindComponent from "../common/AutoBindComponent";
import BovenLokaliteitPerInfrastructuurForm from "./BovenLokaliteitPerInfrastructuurForm";
import BovenLokaliteitPerInfrastructuurPageHelper from "./BovenLokaliteitPerInfrastructuurPageHelper";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import EasterEggHandler from "../common/EasterEggHandler";
import ConfirmModal from "../common/ConfirmModal";
import GenerateGuid from "../../util/guid";
import { orderByPropertyName } from "../../util/orderBy";
import * as types from '../../constants/ComponentConstants';

class BovenLokaliteitPerInfrastructuurPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			requested: null,
			titleSet: false,
			hasUnsavedChanges: false,
			inEditMode: false,
			sjablonen: [],
			center: {
				lat: '',
				lng: ''
			},
			mapKey: GenerateGuid(),
			addBovenlokaliteitPerInfraModalIsOpen: false,
			showLegend: false,
			isLoading: false,
			removeModalIsOpen: false,
			removeInfraIndex: null,
			shouldKeepProject: false,
			infraBinnen600m: false
		};

		this.pageHelper = new BovenLokaliteitPerInfrastructuurPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.BOVENLOKALITEITPERINFRASTRUCTUUR);
	}

	componentWillReceiveProps(nextProps) {
		this.pageHelper.receiveProps(nextProps);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	saveBovenLokaliteitPerInfrastructuur(toSaveBovenLokaliteitPerInfrastructuur, documenten) {
		this.pageHelper.saveBovenLokaliteitPerInfrastructuur(toSaveBovenLokaliteitPerInfrastructuur, documenten);
	}

	isReadyToRender() {
		// entity not loaded? not ready yet...
		if (!this.state.bovenLokaliteitPerInfrastructuur) {
			return false;
		}

		return true;
	}

	componentDidMount() {
		this.easterEggHandler.bind();
	}

	componentWillUnmount() {
		this.easterEggHandler.unbind();

		this.setState({
			isLoaded: false
		});

		if (!this.state.shouldKeepProject) {
			this.props.unloadBovenlokaliteit();
		}
	}

	handleOnDropFiles(component, files) { return this.pageHelper.handleOnDropFiles(component, files); }
	handleOnDeleteFile(component, fileName) { return this.pageHelper.handleOnDeleteFile(component, fileName); }
	handleOnChange(event, i) { return this.pageHelper.handleOnChange(event, i); }
	handleOnSave(event) { return this.pageHelper.handleOnSave(event); }
	handleOnRemoveSportInfrastructuur(event, i, infraBinnen600m) { return this.pageHelper.handleOnRemoveSportInfrastructuur(event, i, infraBinnen600m); }
	handleOnGoToRemoveSportInfrastructuur() { return this.pageHelper.handleOnGoToRemoveSportInfrastructuur(); }
	handleOnCancelRemoveSportInfrastructuur() { return this.pageHelper.handleOnCancelRemoveSportInfrastructuur(); }
	handleOnEdit(event, i) { return this.pageHelper.handleOnEdit(event, i); }
	handleOnAddBovenlokaliteitPerInfraModalIsOpen() { return this.pageHelper.handleOnAddBovenlokaliteitPerInfraModalIsOpen(); }
	handleOnGoToAddBovenlokaliteitPerInfra() { return this.pageHelper.handleOnGoToAddBovenlokaliteitPerInfra(); }
	handleOnCancelAddBovenlokaliteitPerInfraModalIsOpen() { return this.pageHelper.handleOnCancelAddBovenlokaliteitPerInfraModalIsOpen(); }

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}

		let removeText = "";

		if (this.state.removeModalIsOpen.toString() === "true")
			removeText = this.state.infraBinnen600m.toString() === "true" ? `Wil je de manueel toegevoegde sportinfrastructuur ${orderByPropertyName(this.state.bovenLokaliteitPerInfrastructuur.sportinfrastructurenInDeBuurt.filter(i => i.behoortTotMijnProject === false && i.tienMinutenWandelen), "naam")[this.state.removeInfraIndex].naam} verwijderen ?` : `Wil je de manueel toegevoegde sportinfrastructuur ${orderByPropertyName(this.state.bovenLokaliteitPerInfrastructuur.sportinfrastructurenInDeBuurt.filter(i => i.behoortTotMijnProject === false && i.tienMinutenWandelen === false), "naam")[this.state.removeInfraIndex].naam} verwijderen ?`;

		const {
			maxMapFeaturesToLoad,
			osmBaseLayerUrl
		} = this.props;

		return (
			<div>
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.addBovenlokaliteitPerInfraModalIsOpen}
					title="Opgelet: "
					mainText="Hier mag je enkel een infrastructuur toevoegen die zich binnen een straal van 600m bevindt."
					confirmAction={this.handleOnGoToAddBovenlokaliteitPerInfra}
					cancelAction={this.handleOnCancelAddBovenlokaliteitPerInfraModalIsOpen}
					confirmText="Ga verder"
					cancelText="Terug" />
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.removeModalIsOpen}
					title="Opgelet:"
					mainText={removeText}
					confirmAction={this.handleOnGoToRemoveSportInfrastructuur}
					confirmText="Ga verder"
					cancelText="Terug"
					cancelAction={this.handleOnCancelRemoveSportInfrastructuur} />
				<BovenLokaliteitPerInfrastructuurForm
					bovenLokaliteitPerInfrastructuur={this.state.bovenLokaliteitPerInfrastructuur}
					infrastructuur={this.props.infrastructuur}
					disabled={this.props.disabled}
					center={this.state.center}
					inEditMode={this.state.inEditMode}
					errors={this.props.errors}
					onChange={this.handleOnChange}
					onSave={this.handleOnSave}
					soortenInfrastructuur={this.props.soortenInfrastructuur}
					soortenInfrastructuurAll={this.props.soortenInfrastructuurAll}
					tooltip={this.state.tooltip}
					onAddSportinfrastructuurInDeBuurt={this.handleOnAddBovenlokaliteitPerInfraModalIsOpen}
					onDelete={this.handleOnRemoveSportInfrastructuur}
					onEdit={this.handleOnEdit}
					currentSportinfrastructurenInDeBuurtIndex={this.state.currentSportinfrastructurenInDeBuurtIndex}
					newCoords={this.state.newCoordinates}
					mapKey={this.state.mapKey}
					fileTypes={this.props.fileTypes}
					sjablonen={this.state.sjablonen}
					documenten={this.state.documenten}
					fileSessionStarted={this.state.fileSessionStarted}
					onDropFiles={this.handleOnDropFiles}
					onDeleteFile={this.handleOnDeleteFile}
					maxMapFeaturesToLoad={maxMapFeaturesToLoad}
					osmBaseLayerUrl={osmBaseLayerUrl}
					validationMessageType={this.props.validationMessageType}
				/>
			</div>
		);
	}
}

BovenLokaliteitPerInfrastructuurPage.propTypes = {
	bovenLokaliteitPerInfrastructuur: PropTypes.object,
	disabled: PropTypes.bool,
	currentSportinfrastructurenInDeBuurtIndex: PropTypes.number
};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;
	const infrastructuurId = ownProps.params.infrastructuurId;
	const bovenLokaliteitPerInfrastructuur = state.bovenLokaliteitPerInfrastructuur;
	const shouldKeepProject = state.shouldKeepProject;
	const infrastructuur = state.infrastructuren.find(e => e.id === infrastructuurId);
	const disabled = state.ajaxCounter > 0 || state.settings.lockAllDossiers || ((bovenLokaliteitPerInfrastructuur.item) && bovenLokaliteitPerInfrastructuur.item.redenVanStatus == 121450000);
	const soortenInfrastructuur = !(bovenLokaliteitPerInfrastructuur && bovenLokaliteitPerInfrastructuur.item && (bovenLokaliteitPerInfrastructuur.item.andereInfrastructurenBeschikbaar === true || bovenLokaliteitPerInfrastructuur.item.andereInfrastructurenBeschikbaar === "true")) ? state.referentie.soortenInfrastructuur.filter((x, i) => i > 0) : state.referentie.soortenInfrastructuur;
	return {
		disabled: disabled,
		bovenLokaliteitPerInfrastructuur: bovenLokaliteitPerInfrastructuur.item,
		documenten: bovenLokaliteitPerInfrastructuur.documenten,
		isLoaded: bovenLokaliteitPerInfrastructuur.isLoaded,
		isLoading: bovenLokaliteitPerInfrastructuur.isLoading,
		bovenLokaliteitPerInfrastructuurSaved: bovenLokaliteitPerInfrastructuur.isSaved,
		fileSessionStarted: bovenLokaliteitPerInfrastructuur.fileSessionStarted,
		errors: bovenLokaliteitPerInfrastructuur.errors,
		validationMessageType: bovenLokaliteitPerInfrastructuur.hasValidationErrors ? types.ValidationMessageTypes.ERROR : types.ValidationMessageTypes.WARNING,
		dossierId: dossierId,
		infrastructuur: infrastructuur,
		infrastructuurId: infrastructuurId,
		soortenInfrastructuur: soortenInfrastructuur,
		soortenInfrastructuurAll: state.referentie.soortenInfrastructuurAll,
		fileTypes: state.settings.fileTypes,
		shouldKeepProject: shouldKeepProject,
		maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
		osmBaseLayerUrl: state.settings.osmBaseLayerUrl
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		saveBovenLokaliteitPerInfrastructuur: bindActionCreators(bovenLokaliteitPerInfrastructuurActions.saveBovenLokaliteitPerInfrastructuur, dispatch),
		loadBovenLokaliteitPerInfrastructuur: bindActionCreators(bovenLokaliteitPerInfrastructuurActions.loadBovenLokaliteitPerInfrastructuur, dispatch),
		bovenLokaliteitPerInfrastructuurLoaded: bindActionCreators(bovenLokaliteitPerInfrastructuurActions.bovenLokaliteitPerInfrastructuurLoaded, dispatch),
		loadInfrastructurenByDossierId: bindActionCreators(infrastructuurActions.loadInfrastructurenByDossierId, dispatch),
		unloadBovenlokaliteit: bindActionCreators(infrastructuurActions.unloadBovenlokaliteit, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadBovenLokaliteitPerInfrastructuurPageLayout, dispatch),
		uploadDocument: bindActionCreators(documentActions.uploadInfrastructuurDocument, dispatch),
		deleteDocument: bindActionCreators(documentActions.deleteInfrastructuurDocument, dispatch),
		startFileSession: bindActionCreators(documentActions.startInfrastructuurFileSession, dispatch),
		endFileSession: bindActionCreators(documentActions.endInfrastructuurFileSession, dispatch),
		getContent: bindActionCreators(documentActions.getInfrastructuurContent, dispatch),
		getSjablonen: bindActionCreators(documentActions.getSjablonen, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(BovenLokaliteitPerInfrastructuurPage));
